
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_ps6c5_98",
  "has-items": "awsui_has-items_dm8gx_ps6c5_108",
  "token": "awsui_token_dm8gx_ps6c5_112",
  "dismiss-button": "awsui_dismiss-button_dm8gx_ps6c5_124",
  "token-disabled": "awsui_token-disabled_dm8gx_ps6c5_158",
  "toggle": "awsui_toggle_dm8gx_ps6c5_173",
  "description": "awsui_description_dm8gx_ps6c5_234"
};
  